import React from "react"
import BoundedInput from "../../../InputForm/BoundedForm"

class InvestmentProjectFormComponent extends React.Component {

	render() {
    const ids          = {
			theme								: "ppi-project-theme",
			subtheme						: "ppi-project-subtheme",
			name        				: "ppi-project-name",
			description					: "ppi-project-description",
			accounting_article	: "ppi-project-accounting-article",
			operation_number		: "ppi-project-operation-number",
			prioriy							: "ppi-project-priority",
			fctva								: "ppi-project-fctva"
		}

		return (
			<form onSubmit={this.props.onSubmit}>
				{ this.props.delete
					? <div>Êtes-vous sûr de vouloir supprimer le projet <strong>{this.props.project.name}</strong> ?</div>
					: <div className="columns is-desktop">
							<div className="column">
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.theme}>Thématique</label>
									</span>
									<span className="field-body">
										<span className="field has-addons has-addons-right">
											<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
												<select 
													disabled    = {this.props.submitting}
													id={ids.theme}
													onChange={this.props.onThemeChange}
													value={this.props.theme}
													required>
													<option value="">Sélectionnez un thème</option>
													{this.props.themes.map(theme => (
														<option value={theme.id}>{theme.name}</option>
													))}
												</select>
											</span>
										</span>
									</span>
								</p>
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.theme}>Sous-thématique</label>
									</span>
									<span className="field-body">
										<span className="field has-addons has-addons-right">
											<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
												<select 
													id={ids.subtheme}
													disabled    = {this.props.submitting}
													onChange={this.props.onSubThemeChange}
													value={this.props.subtheme}>
													<option value="">{this.props.theme ? (this.props.themes.find(t => t.id == this.props.theme).themes.length > 0 ? "Sélectionnez une sous-thématique" : "Aucune sous-thématique") : "Veuillez sélectionner un thème"}</option>
													{ this.props.theme
														? this.props.themes.find(t => t.id == this.props.theme).themes.map(theme => (
																<option value={theme.id}>{theme.name}</option>
															))
														: null
													}
												</select>
											</span>
										</span>
									</span>
								</p>
								<div className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.name}>Nom du projet</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<BoundedInput
													className   = "input"
													id          = {ids.name}
													name        = "name"
													min="0"
													max="30"
													recommendedMax="30"
													onChange    = {this.props.onNameChange}
													placeholder = "Nom du projet"
													type        = "text"
													value       = {this.props.name}
													required />
											</span>
										</span>
									</span>
								</div>
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.description}>Description</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<textarea
													className   = "textarea"
													rows				= "5"
													id          = {ids.description}
													name        = "description"
													onChange    = {this.props.onDescriptionChange}
													placeholder = "Description"
													value       = {this.props.description}
													required />
											</span>
										</span>
									</span>
								</p>
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.accounting_article}>Article Comptable</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<input
													className   = "input"
													id          = {ids.accounting_article}
													name        = "accounting_article"
													onChange    = {this.props.onAccountingArticleChange}
													placeholder = "Article Comptable"
													type        = "number"
													value       = {this.props.accounting_article}
													required />
											</span>
										</span>
									</span>
								</p>
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.description}>Numéro d'opération</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<input
													className   = "input"
													id          = {ids.operation_number}
													name        = "operation_number"
													onChange    = {this.props.onOperationNumberChange}
													placeholder = "Numéro d'opération"
													type        = "text"
													value       = {this.props.operation_number}
													required />
											</span>
										</span>
									</span>
								</p>
								<div className="field is-horizontal">
									<div className="field-label is-normal">
										<label className="label" htmlFor={ids.priority}>Priorité</label>
									</div>
									<div className="field-body">
										<div className="field">
											<div className="control">
												<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
													<select
													disabled    = {this.props.submitting}
													id          = {ids.priority}
													name        = "priority"
													value 			= { this.props.priority }
													onChange		= {this.props.onPriorityChange}
													required>
														<option value="1">1</option>
														<option value="2">2</option>
														<option value="3">3</option>
														<option value="4">4</option>
													</select>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="field is-horizontal">
									<div className="field-label"><label className="label" htmlFor={ids.fctva}>Soumis à la FCTVA</label></div>

									<div className="field-body">
										<div className="field is-narrow">
											<div className="control">
												<label className="radio" disabled={this.props.submitting}>
													<input
														checked  = {this.props.fctva === undefined || this.props.fctva === true ? "checked" : false}
														disabled = {this.props.submitting}
														id       = {ids.fctva+"-yes"}
														name     = "fctva"
														onChange = {this.props.onFctvaChange}
														required
														type     = "radio"
														value    = "1" /> Oui
												</label>
											</div>
											<div className="control">
												<label className="radio" disabled={this.props.submitting}>
													<input
														checked  = {this.props.fctva === false ? "checked" : false}
														disabled = {this.props.submitting}
														id       = {ids.fctva+"-no"}
														name     = "fctva"
														onChange = {this.props.onFctvaChange}
														required
														type     = "radio"
														value    = "0" /> Non
												</label>
											</div>
										</div>
									</div>
								</div>


							</div>
						</div>
				}
				<div className="columns">
					{/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							{this.props.delete ? "Supprimer" : (this.props.project ? "Modifier" : "Ajouter")} le projet
						</button>
					</div>
				</div>
			</form>
		)
	}

}

export default InvestmentProjectFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-form-component.js